import React, { useEffect } from 'react';

// 第三方在线客服（LineChat / SaleWisely 公开聊天 SDK）
// 后台客服台: https://app.linechatai.com/c/<pluginId>
const CHAT_PLUGIN_ID =
  process.env.REACT_APP_CHAT_PLUGIN_ID || 'fe98b0f8317b4d7f986a8a90af8e452c';
const CHAT_SDK_URL =
  process.env.REACT_APP_CHAT_SDK_URL ||
  `https://file.salewisely.com/sdk/release/salewisely-bundled.js?appId=${CHAT_PLUGIN_ID}`;

// SDK 只加载一次，多个页面进出复用同一个全局实例
let sdkLoadPromise = null;
const loadChatSdk = () => {
  if (window.SaleWiselySDK) return Promise.resolve(window.SaleWiselySDK);
  if (sdkLoadPromise) return sdkLoadPromise;

  sdkLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = CHAT_SDK_URL;
    script.async = true;
    script.onload = () => {
      if (window.SaleWiselySDK) resolve(window.SaleWiselySDK);
      else reject(new Error('SaleWisely SDK loaded but global is missing'));
    };
    script.onerror = () => {
      sdkLoadPromise = null;
      reject(new Error('SaleWisely SDK failed to load'));
    };
    document.body.appendChild(script);
  });

  return sdkLoadPromise;
};

const readStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch (error) {
    return null;
  }
};

const ChatPage = () => {
  useEffect(() => {
    let cancelled = false;

    const language = localStorage.getItem('language') || 'en';
    const user = readStoredUser();

    // 客服后台能看到是哪个会员在咨询
    const loginInfo = { language, loginConfirmed: true };
    if (user?.id) loginInfo.userId = String(user.id);

    const config = {
      appId: CHAT_PLUGIN_ID,
      fullscreen: true, // 聊天框占满页面（位置由 index.css 限定：顶部到导航上方）
      hiddenClose: true, // 页面不再自带顶部栏，隐藏第三方的关闭按钮
      language
    };

    window._salewiselyConfig = { ...(window._salewiselyConfig || {}), ...config };
    window._salewiselyUser = loginInfo;

    loadChatSdk()
      .then(async (sdk) => {
        if (cancelled) return;
        await sdk.init(config);
        if (cancelled) {
          sdk.destroy?.();
          return;
        }
        sdk.setLoginInfo(loginInfo);
        await sdk.showChat();
      })
      .catch((error) => {
        console.error('Third-party chat SDK error:', error?.message || error);
      });

    return () => {
      cancelled = true;
      // 离开客服页时移除第三方聊天框（否则会在其它页面留下悬浮球）
      try {
        window.SaleWiselySDK?.destroy?.();
      } catch (error) {
        /* ignore */
      }
    };
  }, []);

  // 页面本身只留白底，聊天框由第三方 SDK 全屏渲染（顶部不再有我们自己的头部）
  return <div className="fixed inset-0 bg-white" />;
};

export default ChatPage;
